<style scoped lang='scss'>
	@import '../assets/scss/only-lms/loader';
	@import '../assets/scss/only-lms/animations';
</style>

<template>
	<div class='loader-f6db8wb6o2h' v-if='show == true'>
		<span class='loader-f6db8wb6o2h-pf5phdynvda'>{{ text }}</span>
	</div>
</template>

<script>
	export default {
		props: {
			show: {
				type: Boolean,
				default: false
			},
			text: {
				type: String,
				default: 'Loader text'
			}
		}
	}
</script>